import React, { useEffect, useState } from 'react'
import { ContainerHeader } from './styled'
import { Inline } from '../../../../../../../../../../Components/CustomUi/inline'
import { UploadFileCustom } from '../../../../../../../../../../Components/CustomUi/uploadFileCustom'
import ButtonCustom from '../../../../../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faEye, faFloppyDisk, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'
import { importarMalhaGeral } from '../../../../../meta'
import { Modal } from 'antd'
import { TitleH2 } from '../../../../../../../../../../Components/CustomUi/titleH2'
import { Select } from '../../../../../../../../../../Components/CustomUi/Select'
import { GeoPointFeature, ModalNovaAnalise } from './components/modalNovaAnalise'
import ModalCriarMalha from './components/criarNovaMalha'
import { LabAnaliseItens } from '../../../../../../../../../../services/LabAnalise'
import { ModalVerMalha } from '../modalVerMalha'
import { EditarContorno } from './components/editarContorno'
import { LatLng } from 'leaflet'
import { PropsAnalisesCadastradas } from '../../../../../..'
import { Box } from '../../../../../../../../../../Components/CustomUi/box'

interface PropsHeaderAnalise {
  abrirModalNova: boolean
  setAbrirModalNova: React.Dispatch<React.SetStateAction<boolean>>
  setLoadingShape: React.Dispatch<React.SetStateAction<boolean>>
  malha: any
  setMalha: React.Dispatch<React.SetStateAction<any[]>>
  malhaShp: any[]
  setMalhaShp: React.Dispatch<React.SetStateAction<any[]>>
  tipo_analise_selecionada: string
  setTipo_analise_selecionada: React.Dispatch<React.SetStateAction<string>>
  tipo_analise_selecionada_id: number
  setTipo_analise_selecionada_id: React.Dispatch<React.SetStateAction<number>>
  pontos_selecionados: GeoPointFeature[]
  setPontos_selecionados: React.Dispatch<React.SetStateAction<GeoPointFeature[]>>
  pontos_selecionados_adicionados: PropsAnalisesCadastradas[]
  setPontos_selecionados_adicionados: React.Dispatch<
    React.SetStateAction<PropsAnalisesCadastradas[]>
  >
  pontosTotalMalha: number
  setPontosTotalMalha: React.Dispatch<React.SetStateAction<number>>
  talhaoArea: string
  setTalhaoArea: React.Dispatch<React.SetStateAction<string>>
  talhaoKml: any[]
  setTalhaoKml: React.Dispatch<React.SetStateAction<any[]>>
  grupoAnalises: LabAnaliseItens[]
  analises: any[]
  setAnalises: React.Dispatch<React.SetStateAction<any[]>>
  id: string | number
  setId: React.Dispatch<React.SetStateAction<string | number>>
  cor: string
  setCor: React.Dispatch<React.SetStateAction<string>>
  grupoAnalisesTratado: any[]
}

export const HeaderAnalises: React.FC<PropsHeaderAnalise> = ({
  abrirModalNova,
  setAbrirModalNova,
  setLoadingShape,
  malha,
  setMalha,
  malhaShp,
  setMalhaShp,
  tipo_analise_selecionada,
  setTipo_analise_selecionada,
  tipo_analise_selecionada_id,
  setTipo_analise_selecionada_id,
  pontos_selecionados,
  setPontos_selecionados,
  pontos_selecionados_adicionados,
  setPontos_selecionados_adicionados,
  pontosTotalMalha,
  setPontosTotalMalha,
  talhaoArea,
  setTalhaoArea,
  talhaoKml,
  setTalhaoKml,
  grupoAnalises,
  analises,
  setAnalises,
  id,
  setId,
  cor,
  setCor,
  grupoAnalisesTratado,
}) => {
  const [selecionarTodos, setSelecionarTodos] = useState<boolean>(false)
  const [abrirVerMalha, setAbrirVerMalha] = useState<boolean>(false)
  const [abrirEditarContorno, setAbrirEditarContorno] = useState<boolean>(false)
  const [selecionado, setSelecionado] = useState<number | null>(null)
  const [analises_ver, setAnalises_ver] = useState([])
  const [abrirModalCriarGridAmostral, setAbrirModalCriarGridAmostral] = useState<boolean>(false)

  const onChangeUpload = (info: File[]) => {
    importarMalhaGeral(info, setLoadingShape, setMalha, setMalhaShp, setPontosTotalMalha)
  }

  function fechar() {
    setId(null)
    setCor('')
    setTipo_analise_selecionada('')
    setTipo_analise_selecionada_id(null)
    setPontos_selecionados([])
    setPontos_selecionados_adicionados([])
    setSelecionarTodos(false)
    setAbrirModalNova(false)
  }

  function fecharModalCriarGridAmostral() {
    setAbrirModalCriarGridAmostral(false)
  }

  function verMalhaGeral() {
    setAnalises_ver(analises)
    setAbrirVerMalha(true)
  }

  function fecharVerMalha() {
    setSelecionado(null)
    setAnalises_ver([])
    setAbrirVerMalha(false)
  }

  function fecharEditarContorno() {
    setAbrirEditarContorno(false)
  }

  function salvarPontosSelecionados() {
    const dadosFormatados = pontos_selecionados_adicionados?.map((item) => ({
      id: item?.id || Date.now(),
      cod_analise: item?.cod_analise,
      pontos_selecionados: item?.pontos_selecionados?.map((p) => ({
        ...p,
        COR: p.COR || item?.cor,
      })),
      profundidade: item?.profundidade,
      analise_nome: item?.analise_nome,
      valor: item?.valor,
      cor: item?.cor,
      valor_analise: item?.valor_analise,
    }))

    if (id) {
      setAnalises((prev) =>
        prev.map((analise) => (analise.id === id ? dadosFormatados[0] : analise))
      )
    } else {
      setAnalises((prev) => [...prev, ...dadosFormatados])
    }

    fechar()
  }

  function salvarNovoKml(coords) {
    setTalhaoKml(coords)
  }

  return (
    <ContainerHeader>
      <Inline alignItems='center'>
        <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <ButtonCustom onClick={() => setAbrirModalCriarGridAmostral(true)} icon={<FontAwesomeIcon icon={faPlus} />}>
            Criar malha
          </ButtonCustom>
          <UploadFileCustom
            label='Importar malha geral'
            accept='.dbf, .shp, .shx, .zip'
            onFileSelect={onChangeUpload}
            style={{ height: '40px' }}
          />
        </Box>
        <ButtonCustom
          onClick={() => setAbrirModalNova(true)}
          icon={<FontAwesomeIcon icon={faPlus} />}
          disabled={(malha?.length ?? 0) === 0 || !talhaoArea || grupoAnalises?.length === 0}
        >
          Nova análise
        </ButtonCustom>
      </Inline>
      <Inline alignItems='center' justifyContent='space-between'>
        <div className='infos'>
          <span>Pontos</span>
          <p>{pontosTotalMalha}</p>
        </div>
        <div className='infos'>
          <span>Área</span>
          <p>{talhaoArea ? `${talhaoArea} ha` : '0 ha'}</p>
        </div>
        <ButtonCustom
          type='tertiary'
          onClick={() => setAbrirEditarContorno(true)}
          icon={<FontAwesomeIcon icon={faEdit} />}
          disabled={!talhaoArea || Number(talhaoArea) === 0}
        >
          Editar contorno
        </ButtonCustom>
        <ButtonCustom
          type='secondary'
          onClick={verMalhaGeral}
          icon={<FontAwesomeIcon icon={faEye} />}
          disabled={analises?.length <= 0}
        >
          Ver malha
        </ButtonCustom>
      </Inline>

      <ModalNovaAnalise
        isOpen={abrirModalNova}
        onClose={fechar}
        talhaoGeoJson={talhaoKml}
        pontosTotalMalha={pontosTotalMalha}
        id={id}
        initialPoints={malha}
        cor={cor}
        setCor={setCor}
        tipo_analise_selecionada={tipo_analise_selecionada}
        setTipo_analise_selecionada={setTipo_analise_selecionada}
        tipo_analise_selecionada_id={tipo_analise_selecionada_id}
        setTipo_analise_selecionada_id={setTipo_analise_selecionada_id}
        pontos_selecionados={pontos_selecionados}
        setPontos_selecionados={setPontos_selecionados}
        pontos_selecionados_adicionados={pontos_selecionados_adicionados}
        setPontos_selecionados_adicionados={setPontos_selecionados_adicionados}
        malhaShp={malhaShp}
        setMalhaShp={setMalhaShp}
        selecionarTodos={selecionarTodos}
        setSelecionarTodos={setSelecionarTodos}
        grupoAnalises={grupoAnalises}
        grupoAnalisesTratado={grupoAnalisesTratado}
        salvarPontosSelecionados={salvarPontosSelecionados}
      />

      <ModalCriarMalha
        isOpen={abrirModalCriarGridAmostral}
        onClose={fecharModalCriarGridAmostral}
        talhaoKml={talhaoKml}
        setTalhaoKml={setTalhaoKml}
        setMalha={setMalha}
        setMalhaShp={setMalhaShp}
        setPontosTotalMalha={setPontosTotalMalha}
      />

      <ModalVerMalha
        isOpen={abrirVerMalha}
        onClose={fecharVerMalha}
        talhaoGeoJson={talhaoKml}
        initialPoints={malha}
        analises={analises_ver}
        selecionado={selecionado}
        setSelecionado={setSelecionado}
      />

      <EditarContorno
        aberto={abrirEditarContorno}
        contornoInicial={talhaoKml}
        pontos={malha}
        aoFechar={fecharEditarContorno}
        aoSalvar={salvarNovoKml}
      />

    </ContainerHeader>
  )
}